import { render, staticRenderFns } from "./Accommodation.vue?vue&type=template&id=842f9cc6&scoped=true"
import script from "./Accommodation.vue?vue&type=script&lang=js"
export * from "./Accommodation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842f9cc6",
  null
  
)

export default component.exports